import http from 'helpers/http';

export const serviceImageDownload = {
  getImage: (id: string) => http.downloadHash(`/download/image/${id}`),
};
